import React, { Component } from 'react';
import classnames from 'classnames';

class App extends Component {
  constructor(props) {
    super(props)
    console.log('first constructor')
    const params = this.getParams()
    this.state = {
      activeLanguage: (params.lang) ? params.lang : 'bos',
      dropdownActive: false,
      page: params.page
    }
    window.onpopstate = (e) => {
      e.preventDefault()
      this.onBack()
    }
  }

  componentDidMount() {
    fetch('config/config.json')
    .then(response => response.json())
    .then((json) => {
      this.setState({
        homePageContent: json.homepage,
        navigationConfig: json.navigation,
        loaded: true
      }, this.loadContentData)
    })
    .catch((e) => console.log(e))
  }

  loadContentData() {
    fetch('config/page.download.json')
    .then(response => response.json())
    .then((json) => {
      this.setState({
        download: json
      })
    })
  }

  onBack = () => {
    const params = this.getParams()
    this.setState({
      activeLanguage: params.lang || this.state.activeLanguage || 'bos',
      page: params.page
    })
  }

  goTo = (id) => {
    let params = '?'
    // Language parameter
    if (this.state.activeLanguage) {
      params += `lang=${this.state.activeLanguage}`
    }
    // Page parameter
    if (id && this.state.navigationConfig[id] && !this.state.navigationConfig[id].external) {
      params += `${(params === '?') ? '' : '&'}page=${id}`
    }
    // Reset URL parameters if empty query
    if (params === '?') {
      params = ''
    }
    if (this.state.navigationConfig[id] && this.state.navigationConfig[id].external && this.state.navigationConfig[id].url) {
      window.open(`${this.state.navigationConfig[id].url}${params}`)
      // window.history.pushState({
      //   id: id
      // }, id, `${window.location.protocol}${this.state.navigationConfig[id].url}`)
    } else {
      window.history.pushState({
        id: id
      }, id, `${window.location.origin}${window.location.pathname}${params}`);
      this.setState({ page: id });
    }
  }

  renderLanguagePicker() {
    return <div className="language-picker-container">
      <div
        className={classnames('active-language')}
        onClick={() => { this.setState({ dropdownActive: !this.state.dropdownActive }); }}
      >
        <div className="label">{this.state.homePageContent[this.state.activeLanguage].prefix}:</div>
        <div className={classnames('name', { expanded: this.state.dropdownActive })}>{this.state.homePageContent[this.state.activeLanguage].name}</div>
      </div>
      <div
        className={classnames('dropdown', { expanded: this.state.dropdownActive })}
      >
        {
          Object.keys(this.state.homePageContent).map((k) => {
            const v = this.state.homePageContent[k]
            return (<div
              key={k}
              onClick={this.setActiveLanguge.bind(this, k)}
              className={classnames('item', { selected: this.state.activeLanguage === k })}>
              {v.name}
            </div>)
          })
        }
      </div>
    </div>
  }

  renderOverlay() {
    return <div className="overlay"><div className="text">Uskoro...</div></div>
  }

  renderElement(id, soon) {
    return (<div
      key={id}
      className={`panel ${id}`}
      onClick={ this.goTo.bind(this, id) }
    >
      <div className={`text`}>
        <h2>{ this.state.homePageContent[this.state.activeLanguage][id].title }</h2>
        <article>{ this.state.homePageContent[this.state.activeLanguage][id].desc }</article>
      </div>
      <div className={`image`}/>
      { (soon) ? this.renderOverlay() : null }
    </div>)
  }

  renderContent() {
    switch (this.state.page) {
      case 'download':
        return this.renderDownloadPage()
      default:
        return this.renderHomePage()
    }
  }

  renderHomePage() {
    return <div key="body" className={classnames('body', 'flex', { row: (!this.state.page) }, this.state.page)}>
      { this.renderElement('vizuelni') }
      <div key="half" className="flex column half">
        { this.renderElement('jednostavan') }
        <div key="halfcontainer" className="flex row half">
          { this.renderElement('dinamicki', true) }
          { this.renderElement('download') }
        </div>
      </div>
    </div>
  }

  renderDownloadPage() {
    if (!this.state.download) return null
    const l = this.state.activeLanguage
    return <div key="body" className={classnames('body', 'flex', { row: (!this.state.page) }, this.state.page)}>
      <div className="sections">
        {
          this.state.download.map((section) => {
            const hasImages = section.items.some((i) => i.image)
            return <div key={section.title[l]} className={classnames('section', section.id)}>
              <h2>{this.parse(section.title[l])}</h2>
              {
                (section.text) ? <article>{this.parse(section.text[l])}</article> : null
              }
              <div className={classnames('items', 'flex', 'column', section.id)}>
              {
                section.items.map((item, itemIdx) => {
                  return <div key={`item${itemIdx}`} className={classnames('item', { icon: !hasImages })}>
                    {
                      (item.image) ? <img src={item.image} alt={item.label[l]}/> : null
                    }
                    <h4 key="label">
                      { this.parse(item.label[l]) }
                      { `  ` }
                      { (!hasImages) ? this.renderDocs(item) : null }
                    </h4>
                    { (hasImages) ? <h4 key="docs">{this.renderDocs(item)}</h4> : null }
                  </div>
                })
              }
              </div>
            </div>
          })
        }
      </div>
    </div>
  }

  renderDocs(item) {
    const l = this.state.activeLanguage
    return <span className="docs" key="docs"> [{
      item.documents.map((doc, docIdx) => {
        return <span key={`doc${docIdx}`}>{`${((docIdx > 0) ? ', ' : '')}`}
          <a href={doc.url} target="_blank" rel="noopener noreferrer">{this.parse(doc.label)}</a>
        </span>
      })
    }] {(item.sufix && item.sufix[l]) ? ` - ${item.sufix[l]}` : ''}</span>
  }

  render() {
    if (!this.state.loaded) return null
    return [<div key="header" className="header">
      <div className="left" />
      <div className="logo" onClick={this.goTo.bind(this, undefined)} />
      <div className="right">
        { this.renderLanguagePicker() }
      </div>
    </div>,
    this.renderContent()
    ];
  }

  setActiveLanguge(l) {
    this.setState({
      activeLanguage: l,
      dropdownActive: false
    }, this.goTo.bind(this, this.state.page));
  }

  parse(value) {
    if (!value) return ''
    return value
  }

  getParams() {
    const params = {}
    window.location.search.substring(1).split('&').forEach((str) => {
      const ar = str.split('=')
      params[ar[0]] = ar[1]
    })
    return params
  }
}

export default App;
